import { Icon } from '@eventbrite/eds-icon';
import { StarFill } from '@eventbrite/eds-iconography';
import { gettext } from '@eventbrite/i18n';
import React from 'react';
import {
    EventDetail,
    EventDetailContent,
    EventDetailHeading,
    EventDetailIcon,
    ICON_COLOR,
    ICON_SIZE,
} from '../EventDetail/EventDetail';

type Artist = {
    name: string;
};

type ArtistList = Artist[];

export type PerformersProps = {
    headliners?: ArtistList;
    supporters?: ArtistList;
};

const _getArtists = (artists: ArtistList) =>
    artists.map(({ name }: Artist) => name).join(', ');

export const Performers = ({
    headliners = [],
    supporters = [],
}: PerformersProps = {}) => {
    if (!headliners.length && !supporters.length) {
        return null;
    }

    const LABEL_ID = 'performers-heading';

    return (
        <EventDetail ariaLabelledBy={LABEL_ID}>
            <EventDetailIcon>
                <Icon type={<StarFill />} size={ICON_SIZE} color={ICON_COLOR} />
            </EventDetailIcon>
            <EventDetailContent>
                <EventDetailHeading>
                    <h3 id={LABEL_ID}>{gettext('Performers')}</h3>
                </EventDetailHeading>
                <div className="eds-g-cell eds-g-cell-12-12 has-user-generated-content">
                    {headliners.length > 0 && (
                        <p className="text-stressed">
                            {_getArtists(headliners)}
                        </p>
                    )}
                    {supporters.length > 0 && <p>{_getArtists(supporters)}</p>}
                </div>
            </EventDetailContent>
        </EventDetail>
    );
};
